import React from "react";
import { ItemSchemaGroupEditor } from "../features/item-schema-groups";
import { withRestaurantId } from "../shared/components/layout";

const ItemSchemaGroupEditorWithId = withRestaurantId(ItemSchemaGroupEditor);

const ItemSchemaGroupPage: React.FC = () => {
  return <ItemSchemaGroupEditorWithId />;
};

export default ItemSchemaGroupPage;
